import { PlanPenalty } from '@common/types';
import { TRANSLATE_NOTIFICATION_DICTIONARY } from '@modules/planning/children/by-date/constants/content';

export function translatePenalties(planPenalty: PlanPenalty): PlanPenalty {
  return {
    ...planPenalty,
    StringKey: TRANSLATE_NOTIFICATION_DICTIONARY[planPenalty.StringKey] || planPenalty.StringKey
  };
}
